<!--
  @deprecated 旧料金体系（timeSlotId を持たない体験イベント）向けの料金表示。
  SummarySection / OptionSection / BasicInfoSection の timeSlotId がない経路では現在も使用される。
  旧予約前見積り API の移行後に TotalPriceSectionWithGuestType.vue へ統合すること。
-->
<template>
  <section>
    <div class="bg-beige1 p-4">
      <div class="flex justify-between text-sm md:text-[17px]">
        <p v-if="isGroup" data-testid="groupFee">Group fee ({{ props.numberOfParticipants }} participants)</p>
        <p v-else data-testid="numberOfParticipantsFee">Experience fee</p>
        <p class="whitespace-nowrap" data-testid="experienceFee">JPY {{ props.preReservationPrice.totalExperienceEventPriceIncludingTaxString }}</p>
      </div>
      <div v-if="!isEventSelected">
        <p class="text-gray2">Price may change after date is selected.</p>
      </div>
      <div class="flex justify-between pt-2 text-sm leading-7 md:text-[17px]">
        <p>Interpretation in {{ selectedInterpreterOption?.name }}</p>
        <p class="whitespace-nowrap" data-testid="additionalInterpreterOptionFee">JPY {{ selectedInterpreterOption?.unitPriceIncludingTaxString }}</p>
      </div>
      <div v-for="(option, index) in selectedExperienceEventOptions" :key="index" class="tracking- flex justify-between text-sm leading-7 md:text-[17px]">
        <p>{{ option.name }} × {{ option.count }}</p>
        <p class="whitespace-nowrap" data-testid="additionalExperienceOptionFee">JPY {{ option.totalPriceIncludingTaxString }}</p>
      </div>
      <div class="py-2">
        <div class="flex justify-between pb-2 text-base leading-7 md:text-[17px]">
          <p>Service fee (5%)</p>
          <p class="whitespace-nowrap" data-testid="serviceFee">JPY {{ props.preReservationPrice.serviceFeeIncludingTaxString }}</p>
        </div>
        <div
          v-if="appliedCode && appliedCode.benefitType && appliedCode.benefitType == 'DISCOUNT_PERCENTAGE' && appliedCode.benefitValue != null && appliedCode.benefitValue != 0"
          class="flex justify-between pb-2 text-base leading-7 md:text-[17px]"
        >
          <p>Discount ({{ appliedCode.benefitValue }}%)</p>
          <p class="whitespace-nowrap" data-testid="serviceFee">- JPY {{ props.preReservationPrice.discountAmountString }}</p>
        </div>
        <div
          v-if="appliedCode && appliedCode.benefitType && appliedCode.benefitType == 'DISCOUNT_AMOUNT' && appliedCode.benefitValue != null && appliedCode.benefitValue != 0"
          class="flex justify-between pb-2 text-base leading-7 md:text-[17px]"
        >
          <p>Discount (- JPY {{ appliedCode.benefitValue.toLocaleString() }})</p>
          <p class="whitespace-nowrap" data-testid="discountAmount">- JPY {{ props.preReservationPrice.discountAmountString }}</p>
        </div>
      </div>
      <AtomsBorder1 class="mb-2 bg-beige3" />
      <div class="flex flex-wrap justify-end text-base md:text-[17px]">
        <p class="mr-auto text-[14px] leading-7 md:text-[16px] md:leading-10">Total Price</p>
        <p class="text-[24px] leading-7 md:mr-2 md:text-[26px] md:font-normal md:leading-10 md:tracking-normal" data-testid="totalPrice">
          <span class="text-[11px] md:text-[13px]">JPY</span> {{ props.preReservationPrice.totalPriceIncludingTaxString }}
        </p>
      </div>
      <p class="leading-2 text-right text-[11px] md:text-[13px] md:leading-4">tax & service fee incl.</p>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { WabunkaExperienceViewModel } from '@/models/wabunka/wabunkaExperience';
import type { ExperiencePreReservationPriceViewModel, WabunkaCode } from '@/wabunka-src/features/Experience';
import type { WabunkaExperienceEventViewModel } from '@/wabunka-src/features/Experience/models/experienceEvent';

interface Props {
  defaultExperience?: WabunkaExperienceViewModel;
  selectedExperienceEvent: WabunkaExperienceEventViewModel;
  numberOfParticipants: number;
  appliedCode?: WabunkaCode;
  preReservationPrice: ExperiencePreReservationPriceViewModel;
}

const props = defineProps<Props>();

const isEventSelected = computed(() => props.selectedExperienceEvent.id !== '');
const isGroup = computed<boolean>(() => (props.defaultExperience != null ? props.defaultExperience.chargeType === 'PER_GROUP' : props.selectedExperienceEvent.experience.chargeType === 'PER_GROUP'));

const selectedExperienceEventOptions = computed(() => props.preReservationPrice?.experienceEventOptionPriceSets.filter((option) => option.count > 0));

const selectedInterpreterOption = computed(() => props.preReservationPrice?.interpreterOptionPriceSets.find((option) => option.count === 1));
</script>
